import currencyFilterMixin from "@/mixins/currency-filter-mixin"

let menuItemMixin = {
	mixins: [currencyFilterMixin],
	props: {
		item: Object
	},
	data: function () {
		return {
			isFeatured: false
		}
	},
	computed: {
		slug() {
			return this.$route.params.slug
		},
		hasImage() {
			return this.item && this.item.img && this.item.img != "" && this.item.restaurant_slug && this.item.restaurant_slug.length > 0
		},
		backgroundPath() {
			if (this.item.img) {
				const filenameArr = this.item.img.split('.')
				const sizedFileName = filenameArr[0] + '_' + '500x500.' + filenameArr[1]
				return `${process.env.VUE_APP_BASE_RESTAURANTS_IMAGE_URL}${this.item.restaurant_slug}/${sizedFileName}`
			} else {
				return '';
			}
		},
		itemPagePath() {
			return `${this.$route.path}?item_id=${this.item.id}&menu_id=${this.item.menu_id}`
		}
	},
	methods: {
		productClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Menu Product Clicked",
				data: {
					id: this.item.id,
					is_featured: this.isFeatured ? 1 : 0
				}
			})
		}
	}
}

export default menuItemMixin